import { Component, OnInit, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { PgmData } from 'src/app/models/pgm';
import { LanguageAware } from 'src/app/general/language-aware';
import { EditSystemService } from 'src/app/services/edit-system.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TEditableComponent } from 'src/app/models/editable-component';
import { PopupService } from 'src/app/services/popup.service';
import { PopupType } from 'src/app/models/popup-type';
import { PgmService } from 'src/app/api/system/pgm.service';
import { DropdownItem } from 'src/app/ui/dropdown/dropdown.component';
import { PermissionRole } from 'src/api/v3/common';

@Component({
  selector: 'app-system-pgm',
  templateUrl: './system-pgm.component.html',
  styleUrls: ['./system-pgm.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SystemPgmComponent extends LanguageAware implements OnInit {
  public maxPgmLen = 100;
  public localPgm: PgmData = {
    id: 0,
    area_id: 0,
    control_area: false,
    enabled: false,
    icon: -1,
    name: '',
    queue_no: 0,
    on: false,
    pulseTime: 3,
    type: 'pulse',
    area_no: 0,
    pulse_activated_at: 0,
    io_type: 0,
    io_ability: '',
  };
  public addingNew = false;
  public canEdit = this.systems.activeSystemHelper.can.edit.outputs();

  constructor(
    cdRef: ChangeDetectorRef,
    private es: EditSystemService,
    private router: Router,
    public pgmS: PgmService,
    private pp: PopupService,
    private r: ActivatedRoute,
  ) {
    super(cdRef);
    const that = this;
    const pgm = this.es.getEditableComponent(TEditableComponent.Output);
    if (pgm === undefined) {
      this.router.navigate(this.g.getHomeUrl());
      return;
    }
    this.addingNew = pgm.id === 0;
    this.localPgm = pgm;
    this.tag = 'PGM' + this.localPgm.queue_no;
    this.headerBar.showHeader({
      headerText: pgm.name,
      backUrl: '*',
      actionButtonText: this.systems.activeSystemHelper.can.delete.outputs() && !this.addingNew ? this.trans('general.delete') : '',
      activatedRoute: this.r,
    });
    this.background.setGray();
    const activeSystemId = this.systems.activeSystem.id;
    if ( this.canEdit ) {
      this.footerBar.showFooter(this.trans('general.cancel'), this.addingNew ? this.trans('general.add') : this.trans('general.save'), true, false);
      this.footerBar.onButton1Click = () => {
        const old = that.es.getComponentBeforeModification(TEditableComponent.Output);
        that.revertChanges(activeSystemId, old);
        history.back();
      };
      this.footerBar.onButton2Click = () => {
        that.onDone();
      };
    }
    this.headerBar.onBackClicked = () => {
      const old = that.es.getComponentBeforeModification(TEditableComponent.Output);
      that.revertChanges(activeSystemId, old);
    };
    if (this.systems.activeSystemHelper.can.delete.outputs() && !this.addingNew) {
      this.headerBar.onActionButtonClicked = () => {
        that.deleteOutput();
      };
    }
    if (this.systems.activeSystem.hwType === 'SP3') {
      this.maxPgmLen = 31;
    }
  }

  ngOnInit(): void {}

  public onDone() {
    if (this.localPgm.id === 0) {
      return;
    }
    const that = this;
    const activeSystemId = this.systems.activeSystem.id;
    const pgm = this.es.getComponentBeforeModification(TEditableComponent.Output);
    this.log('Saugom pgm', this.localPgm);
    this.api.post('/edit/pgm', { pgm: this.localPgm }, true).subscribe(
      (result) => {
        if (!result.success) {
          that.revertChanges(activeSystemId, pgm);
          that.toaster.postError(result.error);
        } else {
          that.systems.saveActiveSystem(activeSystemId);
        }
      },
      (error) => {
        that.revertChanges(activeSystemId, pgm);
        that.toaster.postError(that.trans('systems.errors.pgmSaveFailed'));
      }
    );
    history.back();
  }

  private revertChanges(systemID: number, pgm: PgmData) {
    const system = this.systems.getSystem(systemID);
    if (system === undefined) {
      return;
    }

    const systemPgm = system.pgms.find((p) => p.id === pgm.id);
    if (systemPgm === undefined) {
      return;
    }

    systemPgm.name = pgm.name;
    systemPgm.pulseTime = pgm.pulseTime;
    systemPgm.type = pgm.type;
    systemPgm.icon = pgm.icon;
    systemPgm.enabled = pgm.enabled;
    systemPgm.io_type = pgm.io_type;

    if (systemID === this.systems.activeSystem.id) {
      this.systems.saveActiveSystem(system.id);
    }
  }

  public openIconSelection() {
    if ( !this.canEdit ) { return; }
    this.router.navigate(['../pgm-icon-selection'], { relativeTo: this.r });
  }

  public selectTerminal() {
    const that = this;
    const slideoutItems: DropdownItem<number>[] = [];
    for (const iPgm of this.systems.activeSystem.pgms) {
      if (iPgm.io_ability === 'I') {
        continue;
      }
      if (iPgm.enabled) {
        continue;
      }
      slideoutItems.push({
        label: iPgm.name,
        value: iPgm.id,
      });
    }
    this.pp.showSlideout<DropdownItem<number>>(
      {
        headerText: this.trans('systems.labels.selectTerminal'),
        items: slideoutItems,
        onSubmit: (res) => {
          const selectedPgm = that.systems.activeSystem.pgms.find((p) => p.id === res.value);
          if (that.localPgm.id !== 0) {
            that.revertChanges(that.systems.activeSystem.id, that.es.getComponentBeforeModification(TEditableComponent.Output));
          }
          that.es.beginComponentEdit(TEditableComponent.Output, selectedPgm.id, selectedPgm);
          that.localPgm = selectedPgm;
          selectedPgm.enabled = true;
          selectedPgm.io_type = 2; // Output
        },
      },
      PopupType.SlideoutWithValue
    );
  }

  private deleteOutput() {
    this.localPgm.enabled = false;
    this.localPgm.io_type = 0;
    this.onDone();
  }

  public changeType(type: 'level' | 'pulse') {
    if ( !this.canEdit ) { return; }
    this.localPgm.type = type;
  }
}
